
import axios, { AxiosResponse } from "axios";
import AxiosService from "./Axios";

class FileApi {
    
    public static UPLOAD_URL = '/api/file/upload';

}

export default FileApi;
